module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAYAAADEtGw7AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAFqADAAQAAAABAAAAFgAAAAAcITNaAAAAYklEQVQ4EWP8b2HhyfD//ywGBgYZIKYGeMLAyJjG+N/c/DHQNGoZCnPYEyYaGAoyXAZkME3AqMHwYB0NitGggIcAnDGaKkaDAh4CcAZNU8UTuDXUYwCrJmDFBzSPmoaDK1MAlVwNy5GpTy4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-form-ui/stop.png
// module id = o7NW
// module chunks = 46